import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface FormInputSignature {
  Element: HTMLDivElement;
  Args: {
    id: string;
    type?: string;
    label: string;
    placeholder?: string;
    value?: string;
    required?: boolean;
    onInput?: (e: Event) => void;
    class?: string;
  };
}

export default class FormInput extends Component<FormInputSignature> {
  @tracked isFocused = false;

  get type() {
    return this.args.type || 'text';
  }

  get placeholder() {
    return this.args.placeholder || this.args.label;
  }

  get inputClass() {
    const baseClass =
      'rounded-2xl bg-white/5 border border-white/10 px-4 py-3 outline-none w-full';
    return this.args.class ? `${baseClass} ${this.args.class}` : baseClass;
  }

  get containerClass() {
    return this.isFocused ? 'sci-input-wrapper is-focused' : 'sci-input-wrapper';
  }

  @action
  handleBlur() {
    this.isFocused = false;
  }

  @action
  handleFocus() {
    this.isFocused = true;
  }

  <template>
    <div ...attributes>
      <label for={{@id}} class="sr-only">{{@label}}</label>
      <div class={{this.containerClass}}>
        <div class="sci-input-container">
          <input
            id={{@id}}
            type={{this.type}}
            required={{@required}}
            class="sci-input {{this.inputClass}}"
            placeholder={{this.placeholder}}
            value={{@value}}
            {{on "input" @onInput}}
            {{on "focus" this.handleFocus}}
            {{on "blur" this.handleBlur}}
          />
        </div>
      </div>
    </div>
  </template>
}
